import { useState, useEffect } from 'react';
import { useAuth } from '../../utils/AuthContext';
import { fetchUserLocation } from '../../utils/apiCalls';
import CalendarView from '../../CalendarView';

export default function UserDashboard() {
    const { user, token } = useAuth();
    const [locationData, setLocationData] = useState(null);

    useEffect(() => {
        if (!user || !token) return;
        const loadLocationData = async () => {
            try {
                const data = await fetchUserLocation(token, user.location_id);
                setLocationData(data?.[0] ??  null); 
            } catch(error) {
                console.error('Failed to fetch location', error);
            }
        };
        loadLocationData();
    }, [token, user])

    return (
        <section>
            <div className='flex justify-end'>
                <img src="/assets/invoco_icon_transparent_purple.webp" alt="invoco Logo Icon" className="h-12 w-12"/>
            </div>

            <div className='grid grid-cols-1 gap-3'>
                {locationData && (
                    <CalendarView clinicId={user.clinic_id} clinicName={''} location={locationData} />
                )}
            </div>
        </section>
    )
}
